








import {Component, Vue} from 'vue-property-decorator'
import * as Helper from '@/helpers'

const { version } = require('../../package.json')

@Component
export default class CopyrightFooter extends Vue {
  version: string | null = version
  Helper = Helper
}
